module.exports = __webpack_public_path__ + "img/jcyj_index5.87c83524.jpg";